import { TransferTranslations } from "./transferTranslations.types";

const transferNlTranslations: TransferTranslations = {
    "transferPage": {
        "title": "Transfer",
        "noTransferTitle": "Ik heb geen transfer nodig",
        "noTransferDescription": "Doorgaan zonder transfer naar het station toe te voegen",
        "tneStationPopupTitle": "Transfer nodig vanaf het treinstation?",
        "tneStationPopupDescription": "Wij bieden gedeelde bus- en privétaxitransfers naar geselecteerde Alpenresorts.",
        "tneStationPopupNoTransfer": "Transfer overslaan",
        "tneStationPopupWantTransfer": "Transfer toevoegen",
        "tneStationFilterLabel": "Uw skistation",
        "tneStationCardTitle": "Boek uw transfer naar uw skistation.",
        "tneStationCardDescription": "Een eenvoudige en praktische manier om uw bestemming te bereiken zonder u zorgen te maken over aansluitingen.",
    },
    transferFilters: {
        title: 'Transfer voorkeuren',
        options: {
            shortWaitingTime: 'Korte wachttijd',
            doorToDoor: 'Deur-tot-deur',
            privateGroup: 'Privé - alleen voor uw groep',
            carRental: 'Autoverhuur',
        },
    },
    "bus": {
        title: 'Bus',
        estimatedTransferTime: 'Geschatte transfertijd:',
        note: 'Kan buswissels onderweg vereisen of lopen naar uw verblijf.',
        description: 'Een gedeelde shuttle met vaste tijden en meerdere stopplaatsen. Buswissels of lopen kunnen nodig zijn.'
    },
    "busLesArcs": {
        title: 'Bus',
        estimatedTransferTime: 'Geschatte transfertijd:',
        note: 'Kan buswissels onderweg vereisen of lopen naar uw verblijf.',
        description: 'Een gedeelde shuttle met vaste tijden en meerdere stopplaatsen. Buswissels of lopen kunnen nodig zijn.'
    },
    "taxi": {
        title: 'Taxi',
        estimatedTransferTime: 'Geschatte transfertijd:',
        note: 'Deur-tot-deur service',
        description: 'Een privé-transfer met een gedelegeerde chauffeur voor uw exclusieve gebruik.'
    },
    "funicular": {
        title: 'Funiculaire',
        estimatedTransferTime: 'Geschatte transfertijd:',
        note: 'Deur-tot-deur service',
        description: 'Een funiculaire privé-transfer met een gedelegeerde chauffeur voor uw exclusieve gebruik.'
    }
}

export default transferNlTranslations;